import { createContext, useContext } from "react";

interface DateRange {
  start: string | null;
  end: string | null;
  period?: string;
}

interface TableFilterContextType {
  table: string;
  textSearchField: string | null;
  setTextSearchField: (value: string | null) => void;
  textSearchValue: string | null;
  setTextSearchValue: (value: string | null) => void;
  lastUpdated: DateRange;
  setLastUpdated: (value: DateRange) => void;
  applicationDate: DateRange;
  setApplicationDate: (value: DateRange) => void;
  selectedStatuses: string[];
  setSelectedStatuses: (value: string[]) => void;
  role: string | null;
  setRole: (value: string | null) => void;
}

const TableFilterContext = createContext<TableFilterContextType>({
  table: "",
  textSearchField: null,
  setTextSearchField: () => null,
  textSearchValue: null,
  setTextSearchValue: () => null,
  lastUpdated: { start: null, end: null },
  setLastUpdated: () => null,
  applicationDate: { start: null, end: null },
  setApplicationDate: () => null,
  selectedStatuses: [],
  setSelectedStatuses: () => null,
  role: null,
  setRole: () => null,
});

export const useTableFilterContext = () => useContext(TableFilterContext);

export const TableFilterProvider = TableFilterContext.Provider;
